import { render } from "./tabNav.vue?vue&type=template&id=10d339df"
import script from "./tabNav.vue?vue&type=script&lang=js"
export * from "./tabNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__